export const groupByCommission = (professors = []) => {
  const map = {};

  professors.forEach(p => {
    const key = p.commissionNumber;

    if (!map[key]) {
      map[key] = {
        commissionNumber: key,
        professors: [],
      };
    }

    map[key].professors.push({
      professorEmployeeId: p.professorEmployeeId,
      role: p.role,
    });
  });

  return Object.values(map).sort((a, b) => a.commissionNumber - b.commissionNumber);
};
